export const FETCH_USER_BALANCES = 'FETCH_USER_BALANCES';
export const FETCH_USER_BALANCES_SUCCEED = 'FETCH_USER_BALANCES_SUCCEED';
export const FETCH_USER_BALANCES_FAILED = 'FETCH_USER_BALANCES_FAILED';

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_USER_INFO_SUCCEED = 'UPDATE_USER_INFO_SUCCEED';
export const UPDATE_USER_INFO_FAILED = 'UPDATE_USER_INFO_FAILED';

export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const FETCH_USER_INFO_SUCCEED = 'FETCH_USER_INFO_SUCCEED';
export const FETCH_USER_INFO_FAILED = 'FETCH_USER_INFO_FAILED';

export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';

export const GET_USER_LOGIN_HISTORY = 'GET_USER_LOGIN_HISTORY';
